var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSberpayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "styles_logo__2bSmb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1732_182036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81149 7.72471V10.488L9.38332 12.7837L17.9299 6.32194C17.6279 5.63746 17.249 4.99805 16.8043 4.40934L9.38332 10.0204L5.81149 7.72471Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5935 10.0917C16.5962 10.1564 16.5962 10.2241 16.5962 10.2888C16.5962 14.3704 13.3593 17.6886 9.38393 17.6886C5.40852 17.6886 2.1689 14.3704 2.1689 10.2888C2.1689 6.2073 5.40578 2.88911 9.38118 2.88911C10.8884 2.88911 12.2886 3.36515 13.4472 4.18202L15.2702 2.80179C13.6613 1.46663 11.6105 0.666656 9.37844 0.666656C4.19778 0.666656 0 4.97636 0 10.2917C0 15.607 4.20053 19.9167 9.37844 19.9167C14.5591 19.9167 18.7569 15.607 18.7569 10.2917C18.7569 9.70295 18.7047 9.1255 18.6059 8.56777L16.5935 10.0917Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1732_182036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 20,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberpayLogo);
export default __webpack_public_path__ + "static/media/sberpayLogo.2547290ec562355b95188ce25b558c33.svg";
export { ForwardRef as ReactComponent };